import { IAssetDTO } from '@/dtos';
import { post, remove, UploadResponse, uploadS3, get } from '@/services/apiWrapper';

export const uploadTermsAPI = async (
  file: Blob,
  onProgress?: (percentComplete: number) => void,
) => {
  const body = {
    fileName: 'Signed_Terms_and_Conditions.pdf',
    fileSize: file.size,
  };
  const response = await post<UploadResponse>(`/registration/upload/terms`, body);

  const { url, assetId } = response;

  const returnObj = await uploadS3(url, file, assetId, onProgress);

  return returnObj;
};

export const uploadScreenShotAPI = async (
  teamId: string,
  yearId: string,
  submissionId: string,
  file: File,
  onProgress: (percentComplete: number) => void,
) => {
  const body = {
    fileName: file.name,
    fileSize: file.size,
  };
  const response = await post<UploadResponse>(
    `/team/${teamId}/year/${yearId}/submission/${submissionId}/screenshot/upload`,
    body,
  );
  const { url, assetId } = response;

  const returnObj = await uploadS3(url, file, assetId, onProgress);

  return returnObj;
};

export const uploadMovieAPI = async (
  teamId: string,
  yearId: string,
  submissionId: string,
  file: File,
  onProgress: (percentComplete: number) => void,
) => {
  const body = {
    fileName: file.name,
    fileSize: file.size,
  };

  const response = await post<UploadResponse>(
    `/team/${teamId}/year/${yearId}/submission/${submissionId}/movie/upload`,
    body,
  );

  const { url, assetId } = response;

  const returnObj = await uploadS3(url, file, assetId, onProgress);

  return returnObj;
};

export const uploadScreeningCopyAPI = async (
  teamId: string,
  yearId: string,
  submissionId: string,
  file: File,
  onProgress: (percentComplete: number) => void,
) => {
  const body = {
    fileName: file.name,
    fileSize: file.size,
  };

  const response = await post<UploadResponse>(
    `/team/${teamId}/year/${yearId}/submission/${submissionId}/screeningCopy/upload`,
    body,
  );

  const { url, assetId } = response;

  const returnObj = await uploadS3(url, file, assetId, onProgress);

  return returnObj;
};

export const uploadTeamVideoAPI = async (
  teamId: string,
  yearId: string,
  submissionId: string,
  file: File,
  onProgress: (percentComplete: number) => void,
) => {
  const body = {
    fileName: file.name,
    fileSize: file.size,
  };

  const response = await post<UploadResponse>(
    `/team/${teamId}/year/${yearId}/submission/${submissionId}/teamVideo/upload`,
    body,
  );

  const { url, assetId } = response;

  const returnObj = await uploadS3(url, file, assetId, onProgress);

  return returnObj;
};

export const uploadBTSVideoAPI = async (
  teamId: string,
  yearId: string,
  submissionId: string,
  file: File,
  onProgress: (percentComplete: number) => void,
) => {
  const body = {
    fileName: file.name,
    fileSize: file.size,
  };

  const response = await post<UploadResponse>(
    `/team/${teamId}/year/${yearId}/submission/${submissionId}/bts/upload`,
    body,
  );

  const { url, assetId } = response;

  const returnObj = await uploadS3(url, file, assetId, onProgress);

  return returnObj;
};

export const getVideoAssetAPI = async (assetId: string): Promise<IAssetDTO> => {
  const response = await get<IAssetDTO>(`/asset/${assetId}`);
  return response;
};

export const uploadSubmissionReleaseAPI = async (
  submissionId: string,
  file: File,
  typeId: string,
  onProgress: (percentComplete: number) => void,
): Promise<IAssetDTO> => {
  const body = {
    fileName: file.name,
    fileSize: file.size,
    typeId: typeId,
  };
  const response = await post<UploadResponse>(`/teams/${submissionId}/release/upload`, body);
  const { url, assetId } = response;

  const returnObj = await uploadS3(url, file, assetId, onProgress);

  return returnObj;
};

export const uploadTeamLogoAPI = async (
  teamId: string,
  file: File,
  onProgress: (percentComplete: number) => void,
) => {
  const body = {
    fileName: file.name,
    fileSize: file.size,
  };

  const response = await post<UploadResponse>(`/team/${teamId}/avatar/upload`, body);

  const { url, assetId } = response;

  const returnObj = await uploadS3(url, file, assetId, onProgress);

  return returnObj;
};

export const saveAvatarAPI = async (file: File, onProgress: (percentComplete: number) => void) => {
  const body = {
    fileName: file.name,
    fileSize: file.size,
  };

  const response = await post<UploadResponse>(`/users/avatar/upload`, body);

  const { url, assetId } = response;

  const returnObj = await uploadS3(url, file, assetId, onProgress);

  return returnObj;
};

export const uploadContestReleaseAPI = async (
  contestId: string,
  file: File,
  typeId: string,
  onProgress: (percentComplete: number) => void,
) => {
  const body = {
    fileName: file.name,
    fileSize: file.size,
  };

  const response = await post<UploadResponse>(`/contest/${contestId}/release/upload`, body);

  const { url, assetId } = response;

  const returnObj = await uploadS3(url, file, assetId, onProgress);

  return returnObj;
};

export const uploadContestMovieAPI = async (
  teamId: string,
  yearId: string,
  file: File,
  onProgress: (percentComplete: number) => void,
) => {
  const body = {
    fileName: file.name,
    fileSize: file.size,
  };

  const response = await post<UploadResponse>(
    `/team/${teamId}/year/${yearId}/contest/upload`,
    body,
  );

  const { url, assetId } = response;

  const returnObj = await uploadS3(url, file, assetId, onProgress);

  return returnObj;
};

export const deleteContestAPI = async (contestId: string) => {
  const api = remove(`/team/contest/${contestId}`);
  return api;
};

export const deleteReleaseFromContestAPI = async (contestId: string, releaseId: string) => {
  const api = remove(`/team/contest/${contestId}/release/${releaseId}`);
  return api;
};

export const deleteReleaseFromSubmissionAPI = async (submissionId: string, releaseId: string) => {
  const api = remove(`/team/submission/${submissionId}/release/${releaseId}`);
  return api;
};

export const uploadRegistrationValidationAPI = async (
  file: File,
  onProgress: (percentComplete: number) => void,
) => {
  const body = {
    fileName: file.name,
    fileSize: file.size,
  };
  const response = await post<UploadResponse>(`/registration/upload/validation-asset`, body);

  const { url, assetId } = response;

  const returnObj = await uploadS3(url, file, assetId, onProgress);

  return returnObj;
};
